import Vue from 'vue'
import Vuex from 'vuex'
import user from "./modules/user";
import userTypes from "./modules/userTypes";
import products from "./modules/products";
import stationType from "./modules/stationType";
import unit from "./modules/unit";
import states from "./modules/states";
import templates from "./modules/templates";
import createPersistedState from "vuex-persistedstate";
import masters from "./masters"
import notification from "./modules/notification"
import subscription from "./modules/subscription"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: '2.0.0',
    masters: masters
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    userTypes,
    products,
    stationType,
    unit,
    templates,
    states,
    notification,
    subscription
  },
  plugins: [createPersistedState()],
})
